/* global require */
'use_strict';

/**
 * Manages sign-in button.
 */
export class SignIn {

    /**
     * @var {Element} sign_in_button will allow customers to sign in with the email that has an account.
     * @var {HTMLInputElement} sign_in_email_input for form validation.
     * @var {HTMLInputElement} sign_in_password_input for form validation.
     * @var {Element} register_button to allow customers to register an account on valid submission.
     * @var {HTMLInputElement} register_email_input
     * @var {HTMLInputElement} register_password_1
     * @var {HTMLInputElement} register_password_2
     * @var {HTMLInputElement} register_firstname_input
     * @var {HTMLInputElement} register_phone_input
     */
    sign_in_button: Element;
    sign_in_email_input: HTMLInputElement;
    sign_in_password_input: HTMLInputElement;
    register_button: Element;
    register_email_input : HTMLInputElement;
    register_password_1 : HTMLInputElement;
    register_password_2 : HTMLInputElement;
    register_firstname_input : HTMLInputElement;
    register_phone_input : HTMLInputElement;

    /**
     * @returns {SignIn}.
     */
    constructor() {
        this.sign_in_button = document.querySelector('.ty-login .ty-btn__login');
        this.sign_in_email_input = <HTMLInputElement> document.getElementById('login_main_login');
        this.sign_in_password_input = <HTMLInputElement> document.getElementById('psw_main_login');
        if (this.sign_in_button) {
            this.sign_in_button.addEventListener('click', () =>  {this.handle_loading_spinner("sign_in")});
        }

        this.register_button = document.querySelector('#save_profile_but');
        this.register_email_input = <HTMLInputElement> document.getElementById('email');
        this.register_password_1 = <HTMLInputElement> document.getElementById('password1');
        this.register_password_2 = <HTMLInputElement> document.getElementById('password2');
        this.register_firstname_input = <HTMLInputElement> document.querySelector('.ty-first-name input.ty-input-text');
        this.register_phone_input = <HTMLInputElement> document.querySelector('.ty-phone input.ty-input-text');
        if (this.register_button) {
            this.register_button.addEventListener('click', () => {this.handle_loading_spinner("register")});
        }
    }

    /**
     * Apply loading spinner to the page based on validity of the form that is submitted.
     * 
     * @returns {void}
     */
    handle_loading_spinner (button_clicked) : void {
        let valid_submission;
        if (button_clicked == "register") {
            valid_submission = this.validate_registration_inputs();
        } else if (button_clicked == "sign_in") {
            valid_submission = this.validate_sign_in_inputs();
        }
        
        if (valid_submission) {
            // Show the loading spinner
            $.toggleStatusBox('show', {
                overlay: true,
                statusContent: '<span class="ty-ajax-loading-box-with__text-wrapper">Loading</span>',
                statusClass: 'ty-ajax-loading-box_text_block'
            });
        }    
    }

    /**
     * Validate the inputs of the registration form.
     * 
     * @returns {boolean}
     */
    validate_registration_inputs () : boolean {
        const email_regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        const phone_regex = /^([+]?[0-9])?\(?([0-9]{3})\)?[- ]?([0-9]{3})[- ]?([0-9]{4})$/;

        if (
            this.register_email_input.value.match(email_regex) &&
            this.register_password_1.value.length > 0 &&
            this.register_password_2.value.length > 0 &&
            (this.register_password_1.value == this.register_password_2.value) &&
            this.register_firstname_input.value.length > 0 &&
            this.register_phone_input.value.match(phone_regex)
        ) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Validate the inputs of the main sign in form.
     *
     * @returns {boolean}
     */
    validate_sign_in_inputs () : boolean {
        const email_regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (this.sign_in_email_input.value.match(email_regex) && this.sign_in_email_input.value.length > 0 && this.sign_in_password_input.value.length > 0) {
            return true;
        } else {
            return false;
        }
    }
}

/**
 * Initialize the sign-in form.
 * @return {void}
 */
export function init_sign_in() {
    if (document.getElementsByClassName('ty-btn__login').length > 0) {
        (() => new SignIn())();
    }
}
